"use client";

import type { ReactElement } from "react";
import { GanttToolbarButton } from "./GanttToolbarButton";

export interface GanttToolbarControlsProps {
  onScrollToToday: () => void;
  onZoomOut: () => void;
  onZoomIn: () => void;
  isTodayDisabled: boolean;
  isZoomOutDisabled: boolean;
  isZoomInDisabled: boolean;
}

export function GanttToolbarControls({
  onScrollToToday,
  onZoomOut,
  onZoomIn,
  isTodayDisabled,
  isZoomOutDisabled,
  isZoomInDisabled,
}: GanttToolbarControlsProps): ReactElement {
  return (
    <>
      <GanttToolbarButton
        onClick={onScrollToToday}
        label="Center today"
        disabled={isTodayDisabled}
      >
        Today
      </GanttToolbarButton>
      <GanttToolbarButton
        onClick={onZoomOut}
        label="Zoom out"
        disabled={isZoomOutDisabled}
      >
        −
      </GanttToolbarButton>
      <GanttToolbarButton
        onClick={onZoomIn}
        label="Zoom in"
        disabled={isZoomInDisabled}
      >
        +
      </GanttToolbarButton>
    </>
  );
}
